var render = function render(){var _vm=this,_c=_vm._self._c;return _c('table-gantt',{ref:"gantt",staticClass:"mx-1 text-2xs",attrs:{"tasks":_vm.filteredTasks,"options":_vm.options,"agenda":_vm.agenda,"minDate":_vm.options.minDate,"maxDate":_vm.options.maxDate}})
}
var staticRenderFns = []

export { render, staticRenderFns }